module.exports = __webpack_public_path__ + "static/media/main_05.cd529956.png";